import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/common/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { PurchaseOrderList, PurchaseOrderDetail } from './pages/PurchaseOrders';
import { CustomerList, CustomerDetail } from './pages/Customers';
import { PaymentTermList, PaymentTermDetail } from './pages/PaymentTerms';
import { InvoiceList, InvoiceDetail } from './pages/Invoices';
import Milestones from './pages/Milestones';
import Revenue from './pages/Revenue';
import UnbilledRevenue, { UnbilledRevenueDetail } from './pages/UnbilledRevenue';
import Templates from './pages/Templates';
import Disputes from './pages/Disputes';
import AuditLog from './pages/AuditLog';
import AdminSettings from './pages/AdminSettings';
import BulkUpload from './pages/BulkUpload';
import PlatformAdmin from './pages/PlatformAdmin';
import AccountLedger from './pages/AccountLedger';
import AutoRenew from './pages/AutoRenew';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 4000, style: { borderRadius: '10px', fontSize: '14px' } }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/auto-renew" element={<PrivateRoute><AutoRenew /></PrivateRoute>} />
          <Route path="/purchase-orders" element={<PrivateRoute><PurchaseOrderList /></PrivateRoute>} />
          <Route path="/purchase-orders/:id" element={<PrivateRoute><PurchaseOrderDetail /></PrivateRoute>} />
          <Route path="/customers" element={<PrivateRoute><CustomerList /></PrivateRoute>} />
          <Route path="/customers/:id" element={<PrivateRoute><CustomerDetail /></PrivateRoute>} />
          <Route path="/payment-terms" element={<PrivateRoute><PaymentTermList /></PrivateRoute>} />
          <Route path="/payment-terms/:id" element={<PrivateRoute><PaymentTermDetail /></PrivateRoute>} />
          <Route path="/invoices" element={<PrivateRoute><InvoiceList /></PrivateRoute>} />
          <Route path="/invoices/:id" element={<PrivateRoute><InvoiceDetail /></PrivateRoute>} />
          <Route path="/milestones" element={<PrivateRoute><Milestones /></PrivateRoute>} />
          <Route path="/disputes" element={<PrivateRoute><Disputes /></PrivateRoute>} />
          <Route path="/revenue" element={<PrivateRoute><Revenue /></PrivateRoute>} />
          <Route path="/unbilled-revenue" element={<PrivateRoute><UnbilledRevenue /></PrivateRoute>} />
          <Route path="/unbilled-revenue/:id" element={<PrivateRoute><UnbilledRevenueDetail /></PrivateRoute>} />
          <Route path="/templates" element={<PrivateRoute><Templates /></PrivateRoute>} />
          <Route path="/bulk-upload" element={<PrivateRoute><BulkUpload /></PrivateRoute>} />
          <Route path="/platform-admin" element={<PrivateRoute><PlatformAdmin /></PrivateRoute>} />
          <Route path="/account-ledger" element={<PrivateRoute><AccountLedger /></PrivateRoute>} />
          <Route path="/audit-log" element={<PrivateRoute><AuditLog /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><AdminSettings /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
